import * as types from './types'
import * as requests from '@cbgms/api/modules/dashboard/requests'
import * as genericVehicleRequests from '@cbgms/api/modules/generic-vehicle/requests'
import { GETGenericVehicleByRegistrationResponse, GETSearchResponse, IVehicleType, ResultObjectType, VehicleProvider } from '@cbgms/api'
import { AsyncAction } from '@cbgms/base/redux/async-action'

export const getSearch = (params: requests.ISearchParams) =>
  AsyncAction<GETSearchResponse>({
    type: [types.GET_SEARCH, types.GET_SEARCH_SUCCESS, types.GET_SEARCH_FAILED],
    payload: {
      api: 'gms',
      request: requests.getSearch(params)
    }
  })

export const handleSearchLimit = (searchTerm: string, resultLimit = 10, searchParts = false, resultTypes?: ResultObjectType[]) =>
  AsyncAction<GETSearchResponse>({
    type: [types.SEARCH_ALL, types.SEARCH_ALL_SUCCESS, types.SEARCH_ALL_FAILED],
    payload: {
      api: 'gms',
      request: requests.getSearch({
        Q: searchTerm,
        ResultLimit: resultLimit,
        SearchExternalParts: searchParts,
        ResultTypes: resultTypes
      })
    }
  })

export const handleSearchLimitAllCountries = (searchTerm: string, searchAll = true) => ({
  type: [types.SEARCH_ALL, types.SEARCH_ALL_SUCCESS, types.SEARCH_ALL_FAILED],
  payload: {
    api: 'gms',
    request: {
      method: 'GET',
      url: `/modules/dashboard/search?q=${searchTerm}&SearchAllCountries=${searchAll}`
    }
  }
})

export const createVehicle = (vehicle: IVehicleType) => ({
  type: [types.CREATE_VEHICLE, types.CREATE_VEHICLE_SUCCESS, types.CREATE_VEHICLE_FAILED],
  payload: {
    api: 'gms',
    request: {
      method: 'POST',
      url: '/modules/vehicles',
      data: vehicle
    }
  }
})

export const getGenericVehicleByRegistrationViaCarDna = (registration: string) =>
  AsyncAction<GETGenericVehicleByRegistrationResponse>({
    type: [
      types.GET_GENERIC_VEHICLE_BY_REGISTRATION_VIA_CARDNA,
      types.GET_GENERIC_VEHICLE_BY_REGISTRATION_VIA_CARDNA_SUCCESS,
      types.GET_GENERIC_VEHICLE_BY_REGISTRATION_VIA_CARDNA_FAILED
    ],
    payload: {
      api: 'gms',
      request: genericVehicleRequests.getGenericVehicleByRegistration(registration, VehicleProvider.CarDna)
    }
  })
